/* ArtemiStreet - Écran de chargement : logo en particules */
(function () {
  'use strict';
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function run() {
    var el = document.querySelector('.art-loader');
    if (!el) return;
    var canvas = el.querySelector('.art-loader__canvas');
    var bar = el.querySelector('.art-loader__bar span');
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var t0 = performance.now(), MIN = 2600, MAX = 6000, ASM = 2200;
    var ready = document.readyState === 'complete';
    if (!ready) window.addEventListener('load', function () { ready = true; });
    var done = false, closing = false, pts = [];

    function finish() {
      if (done) return;
      done = true;
      try { sessionStorage.setItem('art_loader_seen', '1'); } catch (e) {}
      el.classList.add('is-hidden');
      document.documentElement.classList.remove('art-loading');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 800);
    }
    el.addEventListener('click', finish);
    el.addEventListener('touchstart', finish, { passive: true });

    function sample(drawFn, lw, lh) {
      var off = document.createElement('canvas');
      off.width = lw; off.height = lh;
      var c = off.getContext('2d');
      drawFn(c, lw, lh);
      var data = c.getImageData(0, 0, lw, lh).data;
      var hasAlpha = false, i, bright = 0, dark = 0;
      for (i = 3; i < data.length; i += 4) { if (data[i] < 200) { hasAlpha = true; break; } }
      if (!hasAlpha) {
        for (i = 0; i < data.length; i += 4) {
          if ((data[i] + data[i + 1] + data[i + 2]) / 3 > 128) bright++; else dark++;
        }
      }
      var logoIsBright = bright < dark;
      var step = Math.max(2, Math.round(Math.sqrt((lw * lh) / 2600)));
      var out = [];
      for (var y = 0; y < lh; y += step) {
        for (var x = 0; x < lw; x += step) {
          var k = (y * lw + x) * 4, hit;
          if (hasAlpha) { hit = data[k + 3] > 128; }
          else { var lum = (data[k] + data[k + 1] + data[k + 2]) / 3; hit = logoIsBright ? lum > 128 : lum <= 128; }
          if (hit) out.push([x + (Math.random() - 0.5) * step, y + (Math.random() - 0.5) * step]);
        }
      }
      return out;
    }

    function toParticles(list, lw, lh) {
      var cx = W / 2, cy = H * 0.46;
      for (var i = 0; i < list.length; i++) {
        var a = Math.random() * Math.PI * 2;
        var r = Math.max(W, H) * (0.35 + Math.random() * 0.6);
        pts.push({
          sx: cx + Math.cos(a) * r, sy: cy + Math.sin(a) * r,
          tx: cx + list[i][0] - lw / 2, ty: cy + list[i][1] - lh / 2,
          d: Math.random() * 0.45, s: Math.random() * 1.1 + 0.8, ph: Math.random() * 6.28
        });
      }
    }

    function textFallback() {
      if (pts.length) return;
      try {
        var lw = Math.round(Math.min(W * 0.8, 520)), lh = Math.round(lw * 0.22);
        toParticles(sample(function (c, w, h) {
          c.fillStyle = '#fff'; c.textAlign = 'center'; c.textBaseline = 'middle';
          c.font = '900 ' + Math.round(h * 0.8) + 'px Arial Black, Arial, sans-serif';
          c.fillText('ARTEMISTREET', w / 2, h / 2, w);
        }, lw, lh), lw, lh);
      } catch (e) {}
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var aspect = img.naturalWidth / img.naturalHeight;
        var lw = Math.round(Math.min(W * 0.62, 480, H * 0.4 * aspect));
        var lh = Math.max(1, Math.round(lw / aspect));
        toParticles(sample(function (c, w, h) { c.drawImage(img, 0, 0, w, h); }, lw, lh), lw, lh);
      } catch (e) { textFallback(); }
    };
    img.onerror = textFallback;
    img.src = el.getAttribute('data-logo');

    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function frame(now) {
      if (done) return;
      var elapsed = now - t0;
      ctx.clearRect(0, 0, W, H);
      var t = Math.min(1, elapsed / ASM);
      ctx.globalAlpha = 0.4 + 0.6 * t;
      ctx.fillStyle = '#fff';
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var k = ease(clamp((t - p.d) / (1 - p.d), 0, 1));
        var x = p.sx + (p.tx - p.sx) * k, y = p.sy + (p.ty - p.sy) * k;
        if (k >= 1) { x += Math.sin(now / 520 + p.ph) * 0.6; y += Math.cos(now / 610 + p.ph) * 0.6; }
        ctx.fillRect(x, y, p.s, p.s);
      }
      var prog = Math.min(1, elapsed / MIN);
      if (!ready) prog = Math.min(prog, 0.9);
      bar.style.transform = 'scaleX(' + prog.toFixed(3) + ')';
      if (!closing && ((elapsed >= MIN && ready) || elapsed >= MAX)) {
        closing = true;
        bar.style.transform = 'scaleX(1)';
        setTimeout(finish, 250);
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();